/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     权限控制
  +--------------------------------------------------------------------------------------
*/
import Vue from "vue";
import router from "./router/router";
import whiteList from "./router/whiteList";
import store from "./store/store";

// 页面顶部进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

import { Message } from "element-ui";
import { getAccessToken } from "@/utils/cookie";

router.beforeEach((to, from, next) => {
  sessionStorage.setItem("__FROM_PATH__", from.path);
  NProgress.start();

  // 重复登录，直接跳转至首页
  if (to.path === "/login" && getAccessToken()) {
    return next({ path: "/" });
  }

  // 路由白名单通过
  if (whiteList.indexOf(to.path) > -1) {
    return next();
  }

  // 校验口令，失败跳转至登录页
  if (!getAccessToken()) {
    return next(`/login?redirect=${to.path}`);
  }

  // 挂载动态路由
  if (store.getters.dynamicRoutes.length === 0) {
    // 先拉权限，再生成路由
    store.dispatch("getGodInfoAction").then(() => {});
    store
      .dispatch("getUserInfoAction")
      .then(res => {
        store.dispatch("generateRoutes", res.data.frames).then(() => {
          router.addRoutes(store.getters.dynamicRoutes);
          router.addRoutes([{ path: "*", redirect: "/403" }]);
          return next({ ...to, replace: true }); // hack 方法，确保 addRoutes 已完成
        });

        // 登录后，建立全局ws连接
        // if (Vue.prototype.$im.readyState === -1) {
        //   Vue.prototype.$im.initWs()
        // }
      })
      .catch(err => {
        store.dispatch("fedLogOut").then(() => {
          Message.error(err || "获取用户信息失败，请重新登录！");
          return next({ path: "/" });
        });
      });
  }

  // 切换 Frame
  if (from.meta.frame !== to.meta.frame) {
    store.dispatch("changeFrame", to.meta.frame).then(() => {
      return next();
    });
  }
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});
